import SiteLayout from '@/components/feature/SiteLayout';
import ComicCard from '@/components/feature/ComicCard';
import { useSEO } from '@/hooks/useSEO';
import {
  getBannerComics,
  getLatestComics,
  getPopularComics,
} from '@/utils/comic';
import HeroCarousel from './components/HeroCarousel';
import CategoryQuickNav from './components/CategoryQuickNav';
import ComicGridSection from './components/ComicGridSection';
import PopularList from './components/PopularList';

const stats = [
  { value: '12,800+', label: '收录韩漫作品' },
  { value: '8', label: '热门题材分类' },
  { value: '320+', label: '每日更新章节' },
  { value: '1.2亿', label: '累计在线阅读' },
];

export default function Home() {
  useSEO(
    '韩漫网址-最新韩漫漫画在线阅读平台',
    '韩漫网址为用户提供丰富的韩漫漫画资源，涵盖多种题材分类，支持在线阅读和漫画检索，让您轻松找到喜爱的韩漫作品。',
    '韩漫网址,韩漫,漫画在线阅读,韩漫漫画,漫画平台,漫画下载,漫画推荐,漫画资源',
  );

  const banners = getBannerComics();
  const latest = getLatestComics(10);
  const popular = getPopularComics(8);

  return (
    <SiteLayout>
      <HeroCarousel comics={banners} />

      <section className="border-b border-background-200 bg-background-50">
        <div className="mx-auto max-w-7xl px-4 py-8 md:px-6 md:py-10">
          <h1 className="text-center text-xl font-bold text-foreground-950 md:text-3xl">
            韩漫网址 · 最新韩漫漫画在线阅读平台
          </h1>
          <p className="mx-auto mt-3 max-w-2xl text-center text-sm leading-relaxed text-foreground-600 md:text-base">
            聚合全网优质韩漫资源，恋爱、奇幻、校园、悬疑等题材一站畅读，支持分类浏览与关键词检索。
          </p>
          <div className="mt-7 grid grid-cols-2 gap-4 md:grid-cols-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-lg border border-background-200/80 bg-background-100/60 px-4 py-4 text-center"
              >
                <p className="font-heading text-xl font-bold text-primary-600 md:text-2xl">
                  {s.value}
                </p>
                <p className="mt-1 text-xs text-foreground-500 md:text-sm">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CategoryQuickNav />

      <ComicGridSection
        title="最新更新"
        subtitle="紧跟连载进度，最新章节第一时间上线"
        comics={latest}
        moreTo="/category/all"
        moreLabel="全部漫画"
      />

      <PopularList comics={popular} />

      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">关于韩漫网址</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              韩漫网址是一个专注于韩漫漫画在线阅读的资源聚合平台。我们整合精选韩漫作品，按题材细致分类，
              并提供多维筛选、关键词搜索与便捷的章节阅读体验，让你无需在多个站点之间来回切换。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              本站当前为演示版本，所有漫画内容均为展示用途，不提供真实播放与下载服务。
            </p>
          </div>
          <div className="grid gap-4 sm:grid-cols-3 lg:col-span-2">
            {[
              {
                icon: 'ri-layout-grid-line',
                title: '丰富分类',
                desc: '八大题材细致归类，多条件筛选快速定位心仪作品。',
              },
              {
                icon: 'ri-search-line',
                title: '便捷检索',
                desc: '支持标题与作者全文搜索，模糊匹配也能找到答案。',
              },
              {
                icon: 'ri-book-read-line',
                title: '舒适阅读',
                desc: '纵向滚动阅读、夜间模式与阅读宽度调节，久读不累。',
              },
            ].map((f) => (
              <div
                key={f.title}
                className="rounded-lg border border-background-200/80 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${f.icon} text-xl`} />
                </span>
                <h3 className="mt-3 text-base font-semibold text-foreground-950">{f.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-10 md:py-14">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="mb-6 flex items-end justify-between gap-4">
            <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
              <span className="h-5 w-1 rounded-full bg-secondary-500" />
              猜你喜欢
            </h2>
          </div>
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
            {popular.slice(0, 5).map((c) => (
              <ComicCard key={c.id} comic={c} />
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}